import React from 'react';
import SmartImage from '../../ui/SmartImage';

const SejarahPerusahaan = () => (
    <div className="py-4 lg:py-6">
        <div className="mb-7">
            <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">Perjalanan Perusahaan</span>
            <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">Sejarah Perusahaan</h2>
        </div>
        <div className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_20px_55px_rgba(15,23,42,0.07)]">
            <div className="bg-gradient-to-r from-slate-950 to-[#0b345a] p-4 sm:p-7">
                <SmartImage
                    src="/assets-web/timeline-lti.png"
                    alt="Timeline Sejarah PT Len Telekomunikasi Indonesia"
                    wrapperClassName="w-full rounded-2xl bg-white p-2"
                    className="h-auto w-full object-contain"
                />
            </div>
            <div className="p-6 sm:p-8 lg:p-10">
                <p className="text-base leading-8 text-slate-600 sm:text-lg">
                    Perjalanan PT Len Telekomunikasi Indonesia dimulai sejak 2016, dimulai dengan fase Pre-Planning yang mencakup pendanaan proyek. Selanjutnya, pada tahun yang sama, fase perencanaan proyek dimulai dengan penutupan keuangan. Fase konstruksi dilakukan pada tahun 2018 dan diikuti dengan operasi dan pemeliharaan hingga 2033, untuk memastikan kontribusi jangka panjang bagi telekomunikasi nasional.
                </p>
            </div>
        </div>
    </div>
);

export default SejarahPerusahaan;
